import defaultsDeep from 'lodash/defaultsDeep'
import cloneDeep from 'lodash/cloneDeep'
import dividersDefaults from '../BaseDividers/BaseDividers.defaults'
import baseDefaults from '../Base/Base.defaults'
import baseBackground from '../BaseBackground/BaseBackground.defaults'

export default {
  ...defaultsDeep({
    styles: {
      desktop: {
        box: {
          default: {
            spacing: {
              padding: {
                top: 0,
                bottom: 0,
                left: 8,
                right: 8,
                unit: 'px'
              }
            }
          }
        }
      }
    }
  }, cloneDeep(baseDefaults)),
  dividers: cloneDeep(dividersDefaults),
  background: cloneDeep(baseBackground),
  width: 'fluid',
  borderColor: 'var(--color-primary)',
  maxWidth: {
    desktop: {
      unit: 'px',
      value: 300
    }
  },
  height: 'fitContent',
  maxHeight: {
    desktop: {
      unit: 'px',
      value: 300
    }
  },
  contentAlignment: {
    desktop: 'center'
  }
}
